
























































































import { mapActions, mapGetters } from 'vuex'
import { setCookie } from 'tiny-cookie'
import dataPollingMixin from '@/mixins/data-polling-mixin'
import OrcasLogo from '@/components/OrcasLogo.vue'
import { NAV_LINKS } from '../../constants'
import UserMenu from './UserMenu.vue'
import CookieSettingsDialog from '@/modules/authentication/components/cookie-settings/CookieSettingsDialog.vue'
import ImprovementsDialog from '@/modules/marketplace/components/ImprovementsDialog.vue'
import { loadAllAnalyticsServices } from '@/analytics/analytics-services'
import PaymentPeriodUpdateDialog from '../payment-period/PaymentPeriodUpdateDialog.vue'
import { openLinkInNewTab } from '@/router'
import { isPosteTheme } from '@/components/RenderWithTheme.vue'
import { VUE_APP_TMS_DOMAIN, VUE_APP_TMS_URL } from '@/config'
import ReleaseBanner from '../banner/ReleaseBanner.vue'
import { SEGMENT_EVENTS, trackEvent } from '@/analytics/segment'

export default {
  components: {
    OrcasLogo,
    UserMenu,
    CookieSettingsDialog,
    PaymentPeriodUpdateDialog,
    ImprovementsDialog,
    ReleaseBanner
  },
  mixins: [dataPollingMixin('loadOpenAssignments', ['isNotOnOpenAssignmentsPage'])],
  data() {
    return {
      navOpen: false,
      prevRoute: this.$route.fullPath,
      isDialogShown: false
    }
  },
  computed: {
    ...mapGetters([
      'canUseMAFeature',
      'openAssignmentsCount',
      'userHasAcceptedEssentialCookies',
      'userHasAcceptedAnalyticsCookies',
      'isFirstLogin',
      'hasPermissionAndProperInvoicingTerms',
      'canSeeDialogUponLoggingIn',
      'canUseOrcasTmsPortal'
    ]),
    hasOpenAssignments() {
      return !!this.openAssignmentsCount
    },
    isNotOnOpenAssignmentsPage() {
      return !(
        this.$route.path === NAV_LINKS.ASSIGNMENTS &&
        this.$route.query.progress &&
        this.$route.query.progress === 'open'
      )
    },
    assignmentsBadgeVisibilityClass() {
      return this.hasOpenAssignments ? 'nav-link--with-badge-icon' : ''
    },
    isOldOrcasWithTMSAccess() {
      return this.canUseOrcasTmsPortal && !this.$route.query.iframe
    }
  },
  created() {
    this.navLinks = NAV_LINKS
  },
  mounted() {
    if (!this.userHasAcceptedEssentialCookies) this.$refs.cookieSettingsDialog.open()
    if (this.userHasAcceptedEssentialCookies && this.canSeeDialogUponLoggingIn)
      this.isDialogShown = true
  },
  methods: {
    ...mapActions(['triggerReload', 'loadOpenAssignments']),
    onClickTab() {
      if (this.$route.fullPath === this.prevRoute) this.triggerReload()
      this.prevRoute = this.$route.fullPath
      this.toggleNav()
    },
    toggleNav() {
      this.navOpen = !this.navOpen
    },
    onCookieSeetingsClosed() {
      if (this.isFirstLogin) this.$refs.userMenu.openTeamMemberInvitationsDialog()
      if (this.userHasAcceptedAnalyticsCookies) loadAllAnalyticsServices()
    },
    openFAQ() {
      const faqUrl = isPosteTheme
        ? 'https://faq.sennder.com/orcasitalia'
        : 'https://faq.sennder.com/orcas'
      openLinkInNewTab(faqUrl)
    },
    switchToTms() {
      setCookie('TMSBetaUser', 'true', { domain: VUE_APP_TMS_DOMAIN })
      trackEvent(SEGMENT_EVENTS.SWITCH_TO_NEW_ORCAS)
      window.location.href = VUE_APP_TMS_URL
    }
  }
}
